module.exports = __webpack_public_path__ + "img/question_solid.47599c91.svg";